import React from 'react';

import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import clsx from 'clsx';

import { Currency } from '../../../core/api/general/general.types';
import * as BasketControl from '../../../weborder/BasketControl';
import { PriceTag, Typography } from '../../atoms';

const useStyles = makeStyles((theme: Theme) => ({
  label: {
    margin: 0,
  },
  orderSummaryLine: {
    alignItems: 'center',
    display: 'flex',
    flexFlow: 'row nowrap',
    justifyContent: 'space-between',
    margin: theme.spacing(2, 0),
  },
}));

export type OrderSummaryLineProps = {
  bigPrice?: boolean;
  className?: string;
  currency: Currency;
  dataFd?: string;
  label: string;
  languageCode: string;
  subLabel?: string;
  translate: any;
  value: number;
};

export function OrderSummaryLine(props: OrderSummaryLineProps): JSX.Element {
  const {
    bigPrice,
    className,
    currency,
    dataFd = '',
    label,
    languageCode,
    subLabel,
    translate,
    value,
  } = props;

  const classes = useStyles();

  const localisedPrice = BasketControl.ToCurrency(
    value,
    currency,
    languageCode,
  );

  const orderSummaryLineStyles = clsx(classes.orderSummaryLine, className);

  return (
    <div
      className={orderSummaryLineStyles}
      aria-label={label}
      role="region"
      {...(dataFd ? { 'data-fd': dataFd } : {})}
    >
      <div className={classes.label}>
        <Typography variant="h3">{label}</Typography>
        <Typography variant="body2-secondary">{subLabel}</Typography>
      </div>

      <PriceTag
        hasMenuOptions={false}
        horizontalAlign="right"
        localisedPrice={localisedPrice}
        translate={translate}
        variant={bigPrice ? 'large' : 'medium'}
      />
    </div>
  );
}
